import { Button, EmptyState, ErrorState, LabelCaps, PageHeader, SkeletonRows, Tabs } from '@pm/ui';
import { Lock, Plus } from 'lucide-react';
import { useState } from 'react';
import { TaskCompactRow } from '@/features/tasks/task-bits';
import { TaskCreateDialog } from '@/features/tasks/TaskCreateDialog';
import { useTasks } from '@/lib/queries';

/** SPEC §20 — tarefas pessoais: seção separada e claramente privada. */
export function PersonalTasksPage() {
  const [tab, setTab] = useState<'open' | 'done'>('open');
  const [create, setCreate] = useState(false);
  const { data, isLoading, isError, error, refetch } = useTasks({
    scope: 'PERSONAL',
    status:
      tab === 'open'
        ? ['NOT_STARTED', 'IN_PROGRESS', 'WAITING', 'BLOCKED']
        : ['COMPLETED', 'CANCELED'],
    sort: tab === 'open' ? 'due_at' : 'completed_at',
    dir: tab === 'open' ? 'asc' : 'desc',
    per_page: 100,
  });
  const items = data?.data ?? [];

  return (
    <div className="flex max-w-[960px] flex-col gap-gap-lg">
      <PageHeader
        eyebrow={
          <div className="flex items-center gap-1.5">
            <Lock className="size-3.5 text-text-3" />
            <LabelCaps>Privado · só você vê</LabelCaps>
          </div>
        }
        title="Minhas tarefas"
        subtitle="Nem administradores da organização enxergam esta lista."
        actions={
          <Button variant="primary" onClick={() => setCreate(true)}>
            <Plus /> Tarefa pessoal
          </Button>
        }
      />
      <Tabs
        value={tab}
        onChange={setTab}
        tabs={[
          { value: 'open', label: 'Abertas' },
          { value: 'done', label: 'Encerradas' },
        ]}
      />
      <div className="rounded-md border border-border bg-surface-1">
        {isLoading ? (
          <SkeletonRows />
        ) : isError ? (
          <ErrorState message={error.message} onRetry={() => void refetch()} />
        ) : items.length === 0 ? (
          <EmptyState
            icon={Lock}
            title={tab === 'open' ? 'Nenhuma tarefa pessoal' : 'Nada encerrado ainda'}
            action={
              tab === 'open' ? (
                <Button variant="primary" size="sm" onClick={() => setCreate(true)}>
                  <Plus /> Criar
                </Button>
              ) : undefined
            }
          />
        ) : (
          items.map((t) => <TaskCompactRow key={t.id} task={t} />)
        )}
      </div>
      <TaskCreateDialog
        open={create}
        onOpenChange={setCreate}
        scope="PERSONAL"
        navigateOnCreate={false}
      />
    </div>
  );
}
